<template>
  <div class="create-one-work-or" v-loading="loader">
    <div style="width: 100%">
      <el-form class="desktop-header desktop-show-create" style="justify-content: flex-start">
        <div class="fix-bg"></div>
        <div class="desktop-header-left">
          <h4 style="margin-left: 8px; margin-right: 8px">
            #{{ form.index }}
          </h4>

          <div v-if="$route.params.id && $route.name !== 'onereportsCopy'"
               style="max-width: 320px; display: flex; align-items: center">
            <i style="font-size: 28px; margin-left: 12px" class="el-icon-delete" @click="deleteReport"
               v-if="isEditable"></i>
            <router-link
              :to="`/dashboard/workorders-reports/create/${$route.params.id}/copy`"
              class="i-container"
            >
              <i class="el-icon-document-copy copy-header"></i>
            </router-link>
            <a target="_blank"
               :href="`${apiUrl}/onGenerateWorkOrderToReportExcel%3FprojectId%3D${$store.state.project.id}%26workorderId%3D${$route.params.id}`">
              <img src="@/assets/icon/doc-search.svg" class="doc-search-header">
            </a>

            <i class="el-icon-picture-outline" @click="getImageUrl" style="font-size: 28px; margin-left: 8px; cursor: pointer"> </i>

            <div class="progress-circle progress-circle-header"
                 :style="{color: pStatus(form.totalPercent || 0), borderColor: pStatus(form.totalPercent || 0)}">
              {{ formatNumber(form.totalPercent || 0) }}%
            </div>

            <div class="progress-circle progress-circle-header"
                 v-if="$store.state.project.workorder.analytics === 'progress' "
                 :style="{color:getProfColor(form), borderColor:  getProfColor(form)}">
              {{ formatNumber(form.totalProfPercent || 0) }}%
            </div>
          </div>
        </div>

        <div class="desktop-header-right" style="margin-left: 64px; max-width: 80%; flex: 1">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            v-model="form.datetime"
            :picker-options="pickerOptions"
            type="date"
            class="header-picker"
            :disabled="!isEditable || form.approve"
            placeholder="Укажите дату"
          >
          </el-date-picker>
          <el-input class="header-search" v-model="form.title" placeholder="Заголовок наряда" :disabled="!isEditable"
          ></el-input>
        </div>
      </el-form>
      <el-form class="reports-create workorder-create" label-position="top">
        <div style="display: flex; justify-content: flex-start; margin-bottom: 8px" class="mob-show-create">
          <strong v-if="$store.state.project.plan ">{{ $store.state.project.plan.name }}</strong>
        </div>
        <div class="reports-edit-header mob-show-create" v-if="$route.params.id && $route.name !== 'workorderCopy'">
          <div @click="deleteReport" class="i-container" v-if="isEditable">
            <i class="el-icon-delete"></i>
            <span>Удалить наряд</span>
          </div>
          <router-link
            :to="`/dashboard/workorders-reports/create/${$route.params.id}/copy`"
            class="i-container"
          >
            <i class="el-icon-document-copy"></i>
            <span>Копировать наряд</span>
          </router-link>
          <div class="i-container" v-clipboard:copy="link" v-clipboard:success="onCopy">
            <i class="fa  fa-link" style="font-size: 20px"></i>
            <span>Скопировать ссылку</span>
          </div>
        </div>
        <div class="date-create mob-show-create">
          <div style="display: flex; align-items: center">
            <el-date-picker
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.datetime"
              type="date"
              :disabled="!isEditable"
              placeholder="Укажите дату"
            >
            </el-date-picker>
            <h4 style="margin-left: 8px">
              #{{ form.index }}
            </h4>
          </div>
          <div style="display: flex">
            <div class="progress-circle"
                 :style="{color: pStatus(form.totalPercent || 0), borderColor: pStatus(form.totalPercent || 0)}">
              {{ formatNumber(form.totalPercent || 0) }}%
            </div>
            <div class="progress-circle"
                 style="margin-left: 8px"
                 v-if="$store.state.project.workorder.analytics === 'progress' "
                 :style="{color: form.totalProfPercent > 100 ? '#D32F2F' : '#7CB342', borderColor:  form.totalProfPercent > 100 ? '#D32F2F' : '#7CB342'}">
              {{ formatNumber(form.totalProfPercent || 0) }}%
            </div>
          </div>
        </div>

        <div class="mob-show-create">

          <div :class="['add-btn', {isSelect: isEditable && role === 'admin'}]" v-if="$route.params.id">
            <AddUser
              :isAuthor="true"
              v-if="isEditable && role === 'admin'"
              :isSelect="!!form.executor"
              @add-user="addAuthor"
            />
            <div class="report-li-title">
              Автор: <strong>{{
                ` ` + (newAuthor ? (newAuthor.name || newAuthor.email) : (form.user ? form.user.name || form.user.email : ''))
              }}</strong>
            </div>
          </div>

          <div :class="['add-btn', {isSelect: form.category}]">
            <AddCategory
              v-if="isEditable"
              :isSelect="!!form.category"
              @add-category="addCategory"
            />
            <div class="report-li-title" v-if="form.category">
              Категория: <strong>{{ ` ` + form.category.name }}</strong>
            </div>
          </div>

          <div :class="['add-btn', {isSelect: form.executor}]">
            <AddUser
              v-if="isEditable"
              :isSelect="!!form.executor"
              @add-user="addUser"
            />
            <div class="report-li-title" v-if="form.executor">
              Исполнитель: <strong>{{ ` ` + form.executor.name }}</strong>
            </div>
          </div>

          <div style="margin-top: 20px">
            <filter-select
              :disabled="!isEditable"
              multiple
              v-model="form.notifications"
              label="Уведомить"
              :options="allUsers"
            />
          </div>

        </div>
        <div class="desktop-show-create descktop-line-info">

          <div class="descktop-line-li">
            <strong>Автор</strong>
            <div :class="['add-btn', {isSelect: isEditable && role === 'admin'}]">
              <AddUser
                :isAuthor="true"
                v-if="isEditable && role === 'admin'"
                :isSelect="true"
                @add-user="addAuthor"
              />
              <div class="report-li-title-desktop">
              <span>{{
                  (newAuthor ? (newAuthor.name || newAuthor.email) : (form.user ? (form.user.name || form.user.email) : user.name))
                }}</span>
              </div>
            </div>
          </div>

          <div class="descktop-line-li line-category">
            <strong>Категория</strong>
            <div :class="['add-btn', {isSelect: form.category}]">
              <AddCategory
                v-if="isEditable"
                :isSelect="!!form.category"
                @add-category="addCategory"
              />
              <div class="report-li-title-desktop" v-if="form.category">
                <strong>{{ form.category.name }}</strong>
              </div>
            </div>

          </div>

          <div class="descktop-line-li">
            <strong>Исполнитель</strong>
            <div :class="['add-btn', {isSelect: form.executor}]">
              <AddUser
                v-if="isEditable"
                :isSelect="!!form.executor"
                @add-user="addUser"
              />
              <div class="report-li-title-desktop" v-if="form.executor">
                <span>{{ ` ` + form.executor.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="desktop-show-create two-desc-line">
          <div class="descktop-line-li" style="flex: unset; margin-right: 16px">
            <strong style="margin-bottom: 8px">Уведомления</strong>
            <filter-select
              :disabled="!isEditable"
              multiple
              label="Уведомить"
              v-model="form.notifications"
              hide-label
              :options="allUsers"
            />
          </div>
          <div class="descktop-line-li" style="margin-left: 58px">
            <strong style="margin-bottom: 8px">Срок исполнения</strong>
            <div style="display: flex" class="date-pick-workorder">
              <el-date-picker
                :editable="false"
                :disabled="!isEditable"
                format="yyyy-MM-dd"
                v-model="form.deadline_datetime"
                type="date"
                style="margin-right: 2px"
                placeholder="Укажите дату"
              >
              </el-date-picker>
              <el-date-picker
                :editable="false"
                :disabled="!isEditable"
                format="yyyy-MM-dd"
                v-model="form.deadline_datetime_end"
                type="date"
                style="margin-right: 2px"
                placeholder="Укажите дату"
              >
              </el-date-picker>
            </div>
          </div>

        </div>

        <el-form-item label="Срок исполнения" class="mob-show-create">
          <div style="display: flex" class="date-pick-workorder">
            <el-date-picker
              :editable="false"
              :disabled="!isEditable"
              format="yyyy-MM-dd"
              v-model="form.deadline_datetime"
              type="date"
              style="margin-right: 2px"
              placeholder="Укажите дату"
            >
            </el-date-picker>
            <el-date-picker
              :editable="false"
              :disabled="!isEditable"
              format="yyyy-MM-dd"
              v-model="form.deadline_datetime_end"
              type="date"
              style="margin-right: 2px"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>
        </el-form-item>

        <div class="create-comment mob-show-create" style="margin-top: -20px" v-if="$route.params.id">
          <a target="_blank"
             :href="`${apiUrl}/onGenerateWorkOrderToReportExcel%3FprojectId%3D${$store.state.project.id}%26workorderId%3D${$route.params.id}`">
            <img src="@/assets/icon/doc-search.svg" class="doc-search">
          </a>
          <el-form-item label="Заголовок наряда">
            <el-input v-model="form.title" :disabled="!isEditable"
            ></el-input>
          </el-form-item>
        </div>
        <div class="create-comment mob-show-create" v-else>
          <el-form-item label="Заголовок наряда">
            <el-input v-model="form.title" :disabled="!isEditable"
            ></el-input>
          </el-form-item>
        </div>

        <AddJobsWork
          :isEditable="isEditable"
          :user="user"
          :approve="form.approve"
          ref="addJobsWork"
          :mainForm="form"
          v-if="isLoad"
          :options_works="options_works"
          @update="updateObjects"
          :inputObjects="form.inputObjects"
          :index="calcIndex(form)"
        />

        <div class="main-tech-inputs">
          <template v-if="this.$store.state.project.workorder.prof">
            <div class="tech-name" style="margin-top: 12px">
              <strong style="margin-top: 0">Численность</strong>
              <span
                :style="{color: pStatus(calculatePercentage(profPlanFact.fact|| 0, profPlanFact.plan || 0))}">
                {{ calculatePercentage(profPlanFact.fact || 0, profPlanFact.plan || 0) }}%
              </span>
            </div>
            <div class="job-inputs">
              <el-input class="input" :placeholder="profPlanFact.plan || '0'" disabled></el-input>
              <el-input class="input" :placeholder="profPlanFact.fact || '0'" disabled></el-input>
              <i class="fa fa-chevron-right"></i>
            </div>
          </template>
          <template v-if="this.$store.state.project.workorder.tech">
            <div class="tech-name" style="margin-top: 12px">
              <strong style="margin-top: 0">Техника</strong>
              <span
                :style="{color: pStatus(calculatePercentage(techPlanFact.fact|| 0, techPlanFact.plan || 0))}">
                {{ calculatePercentage(techPlanFact.fact || 0, techPlanFact.plan || 0) }}%
              </span>
            </div>
            <div class="job-inputs">
              <el-input class="input" :placeholder="techPlanFact.plan || '0'" disabled></el-input>
              <el-input class="input" :placeholder="techPlanFact.fact || '0'" disabled></el-input>
              <i class="fa fa-chevron-right"></i>
            </div>
          </template>
        </div>

        <div class="create-comment">
          <el-form-item label="Комментарии">
            <div class="desktop-show-create" style="margin-bottom: 8px">
              <strong style="font-size: 16px">Комментарии</strong>
<!--              <div style="margin-right: 8px" class="plus-btn" @click="addComment">+</div>-->
<!--              <UploadFile-->
<!--                btn-size="small"-->
<!--                :fileListProps="fileList"-->
<!--                @add-file="addFileComment"-->
<!--              />-->

            </div>
            <div class="desktop-show-create" style="flex-direction: column">
              <div :key="index" v-for="(file, index) in comment.files" class="links-list">
                <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
                <i class="el-icon-delete" @click="deleteTmpImg(index)"></i>
              </div>
            </div>
            <Comments ref="comment" v-model="comment.text" :form="form" :all-users="allUsers" :user="user"/>
            <div class="desktop-show-create">
              <el-button style="margin-right: 8px" size="small" @click="addComment">Сохранить комментарий</el-button>
              <UploadFile
                btn-size="small"
                :fileListProps="fileList"
                @add-file="addFileComment"
              />
            </div>
          </el-form-item>
          <div class="report-file mob-show-create">
            <UploadFile
              :fileListProps="fileList"
              @add-file="addFileComment"
            />
            <div :key="index" v-for="(file, index) in comment.files" class="links-list">
              <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
              <i class="el-icon-delete" @click="deleteTmpImg(index)"></i>
            </div>
          </div>
          <el-button class="mob-show-create" size="small" type="primary" style="margin-top: 4px; width: 100%"
                     @click="addComment">Добавить комментарий
          </el-button>
          <div style="margin-top: 50px; margin-bottom: 40px">
            <div v-for="(comment, key) in form.comments" :key="key" class="comments">
              <div class="comment">
                <div class="text">
                  <div class="desc">
                    <strong>{{ comment.user.name || comment.user.email }}: </strong>
                    <span>&nbsp;&nbsp;{{ ` ${comment.text}` }}</span>
                  </div>
                  <a @click="deleteComment(key)"
                     v-if="comment.user.uid === user.uid || (user.role === 'admin' && !user.usePermission)"
                     class="delete-btn">Удалить</a>
                </div>
                <div :key="index" v-for="(file, index) in comment.files" class="links-list">
                  <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
                  <i class="el-icon-delete"
                     v-if="comment.user.uid === user.uid || (user.role === 'admin' && !user.usePermission)"
                     @click="deleteCommentImg(key, index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <div :class="['create-footer']">
          <div style="width: 100%;" class="create-footer-report">
            <div :class="{disabled: !this.isStatus && !isExecutor}"
                 style="display:flex; justify-content: space-between; flex-direction: column"
                 class="filter-footer-report">
              <el-date-picker
                v-if="form.status && (form.status.value === 'DONE' || form.status.value === 'IN_TEST')"
                :editable="false"
                style="margin: 0 0 10px 0"
                format="yyyy-MM-dd HH:mm:ss"
                v-model="form.finish_datetime"
                type="datetime"
                placeholder="Укажите дату"
              ></el-date-picker>
              <filter-select
                v-model="form.status"
                label="Статус задачи"
                hideLabel
                :disabled="(!isExecutor && !isEditable) || (isNotification && !isExecutor)"
                @input="setStatus"
                :options="status_options"
              />
            </div>
            <div style="display:flex; justify-content: space-between">
              <el-button @click="back">Отмена</el-button>
              <el-button type="primary" @click="save">Сохранить</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import AddObjects from '../Reports/components/AddObjects';
import UploadFile from '@/views/Dashboard/Reports/components/UploadFile';
import firebase from 'firebase';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import FilterSelect from '../../../components/FilterSelect';
import AddCategory from "./components/AddCategory";
import AddUser from "./components/AddUser";
import {getRole, getUsersOptions} from "../../../firestore/users";
import VueTribute from 'vue-tribute'
import Comments from "./Comments";
import AddJobsWork from "./components/AddJobsWork";
import AddObjectJobsWork from "./components/AddObjectJobsWork";
import {calculatePercentage, formatNumber, pStatus} from "../../../utils/numberUtils";
import {uniq} from "lodash";
import {getPermission} from "../../../firestore/permission";
import {apiUrl} from "../../../plugins/firebase";
import {getCurrentMonth} from "../../../utils/date";
import axios from "axios";

export default {
  name: 'Create',
  components: {
    AddObjectJobsWork,
    AddJobsWork,
    Comments, AddUser, AddCategory, FilterSelect, UploadFile, AddObjects, Multiselect, VueTribute
  },
  data() {
    return {
      apiUrl,
      isLoad: false,
      searchable: {
        line: false,
      },
      comment: {
        text: '',
        files: [],
      },
      updated: true,
      newAuthor: null,
      fileList: [],
      tributeOptions: {
        trigger: '@',
        noMatchTemplate: () => '<li>Пользователь не найден</li>',
        values: (text, cb) => this.getNames(text, cb)
      },
      loader: false,
      dialogObject: false,
      previewSrc: null,
      loading: true,
      isCreatedUser: false,
      currentId: null,
      user: {},
      current_line: {},
      allUsers: [],
      options_works: [],
      permission: null,
      role: 'admin',
      form: {
        inputObjects: [],
        totalProfFact: 0,
        totalProfNorm: 0,
        notifications: [],
        normative_docs: '',
        totalPercent: 0,
        totalProfPercent: 0,
        status: '',
        datetime: dayjs().format(),
        dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
        deadline_datetime: dayjs().format(),
        deadline_dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
        deadline_datetime_end: dayjs().format(),
        deadline_dateunix_end: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
        finish_datetime: null,
        finish_dateunix: null,
        comments: [],
        title: '',
        description: '',
        object: '',
        executor: '',
        category: '',
        index: 1,
        files: [],
      },
    };
  },

  async mounted() {
    this.currentId = this.$route.params.id
    setTimeout(() => this.init(), 0);
    this.role = await getRole(this.$store.state.project.id);
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));

    const users = await getUsersOptions(this.$store.state.project.id, true)
    this.allUsers = users.filter((u) => !u._data.isCompany)
  },
  watch: {
    '$route.params': {
      handler() {
        this.init();
      },
      deep: true,
    },
    'form.totalPercent'() {
      if (this.$route.params.id) {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('workorders')
          .doc(this.currentId)
          .update({
            totalPercent: this.form.totalPercent,
            totalProfPercent: this.form.totalProfPercent
          })
      }
    }
  },

  computed: {
    pickerOptions() {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateEnd = dayjs(year + '-' + month + '-' + '31' + ' 00:00:00').unix() * 1000

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000

        return {
          disabledDate(time) {
            return time.getTime() > unixDateEnd || time.getTime() < unixDateStart;
          },
        }
      } else {
        return {}
      }
    },
    profPlanFact() {
      let result = {
        plan: 0,
        fact: 0,
        percent: 0,
      }

      this.form.inputObjects.forEach((e) => {
        e.jobs.forEach(({PROF}) => {
          result.fact += PROF.fact || 0
          result.plan += PROF.total || PROF.plan || 0
        })
      })

      return result
    },
    techPlanFact() {
      let result = {
        plan: 0,
        fact: 0,
        percent: 0,
      }

      this.form.inputObjects.forEach((e) => {
        e.jobs.forEach(({TECH}) => {
          result.fact += TECH.fact
          result.plan += TECH.plan || TECH.total
        })
      })

      return result
    },
    isExecutor() {
      const reporter = this.form.executor || {}
      const uid = firebase.auth().currentUser.uid;

      if (this.role === 'editor') {
        return this.isEditable || this.isStatus || reporter.uid === uid || reporter.id === uid
      }

      return reporter.uid === uid || reporter.id === uid
    },
    link() {
      return window.location.href;
    },
    isEditable() {
      if (this.user && this.user.usePermission && this.user.role === 'admin') {
        return false
      }

      if ((this.form.user && this.form.user.uid) === firebase.auth().currentUser.uid) {
        return true
      }

      return this.role === 'admin' || !this.$route.params.id;
    },
    isNotification() {
      const notifications = (this.form.notifications || []).map(({value}) => value)

      return !this.isEditable && !this.isExecutor && notifications.includes(firebase.auth().currentUser.uid)
    },
    isStatus() {
      if (this.user && this.user.usePermission) {
        return false
      }


      if (!this.isEditable || this.isNotification) {
        return this.user.company === this.form.executor.name
      }

      return true
    },
    status_options() {
      const result = [
        {
          label: 'В работе',
          value: 'IN_PROGRESS',
        },
        {
          label: 'Выполнено',
          value: 'IN_TEST',
        }
      ]

      if (this.isEditable) {
        result.push({
          label: 'Завершено',
          value: 'DONE',
        })
      }

      return result;
    }
  },
  methods: {

    getImageUrl() {

      this.loader = true
      const params = `/onUploadArchive/${this.$store.state.project.id}`
      const path = ', workOrderId=' + this.$route.params.id
      const url = `${apiUrl}${params}&queryParams=uid=${firebase.auth().currentUser.uid}${path}`;

      axios.get(url).then(({data}) => {
        this.$message({
          // dangerouslyUseHTMLString: true,
          // message: '<a target="_blank" href="'  + data.data +  '" style="overflow: hidden; text-overflow: ellipsis;     white-space: nowrap;">' + data.data + '/strong>',
          // customClass: 'show-link-message',
          // duration: 10000 * 1000,
          // iconClass: 'el-icon-link',
          // showClose: true,

          dangerouslyUseHTMLString: true,
          message: `
    <div style="display: flex; align-items: center;">
      <i class="el-icon-link"
         style="margin-right: 8px; cursor: pointer;"
         onclick="navigator.clipboard.writeText('${data.data}')">
      </i>
      <a  target="_blank" href="${data.data}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 300px; display: inline-block;">
        ${data.data}
      </a>
    </div>
  `,
          customClass: 'show-link-message',
          duration: 10000,
          showClose: true,
        });

        this.loader = false
      })

    },
    getProfColor(form) {

      if (form.totalProfPercent) {
        return form.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }

      if (form.totalProfNorm === 0 && form.totalProfFact === 0) {
        return '#7CB342'
      } else if (form.totalProfNorm && !form.totalProfFact) {
        return '#7CB342'
      } else if (form.totalProfFact && !form.totalProfNorm) {
        return '#D32F2F'
      } else {
        return form.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }
    },
    addAuthor(user) {
      this.newAuthor = user;
    },
    calcIndex(form) {
      let i = 0

      try {
        this.form.inputObjects.forEach(({jobs}) => {

          if (jobs.length) {
            jobs.forEach((job) => {
              if (job.reports) {
                i += job.reports.length
              }
            })
          }
        })
      } catch (e) {
      }

      return this.form.index + i
    },
    pStatus,
    calculatePercentage,
    formatNumber,
    updateObjects(objects) {
      this.form.inputObjects = [...objects]
      this.form = {...this.form}

      const prof = this.profPlanFact
      const tech = this.techPlanFact

      let total = {
        plan: 0,
        fact: 0
      }

      total.plan += Number(prof.plan || 0)
      total.plan += Number(tech.plan || 0)


      total.fact += Number(prof.fact || 0)
      total.fact += Number(tech.fact || 0)

      for (let obj of this.form.inputObjects) {

        for (let j of obj.jobs) {
          total.plan += Number(j.plan || 0)

          if (j.reports) {
            for (let report of j.reports) {
              total.fact += Number(report.jobs[0].value || report.jobs[0].job.value || 0)
            }
          }
        }

      }


      if (this.$store.state.project.workorder.analytics === 'progress') {
        let totalNorm = 0;
        let totalFact = 0

        this.form.totalProfPercent = 0

        this.form.inputObjects.forEach((obj) => {
          obj.jobs.forEach((job) => {

            if (job.work_type && job.work_type.data) {
              const unit_fo_value = Number(job.work_type && job.work_type.data && job.work_type.data.unit_for_value)
              const {fact, norm} = this.calcValue(job)

              totalNorm += (unit_fo_value * norm)
              totalFact += fact;
            }
          })
        })

        this.form.totalPercent = Number(calculatePercentage(total.fact, total.plan)).toFixed()

        if(totalNorm || totalFact) {
          this.form.totalProfPercent = Number((totalNorm / totalFact) * 100).toFixed(0)
        }

        this.form.totalProfFact = totalFact;
        this.form.totalProfNorm = totalNorm;


      } else {
        this.form.totalPercent = Number(calculatePercentage(total.fact, total.plan)).toFixed()
      }
      this.form = {...this.form}

    },
    calcValue(job) {
      if (!job || !job.reports || !job.reports.length) {
        return {fact: 0, norm: 0}
      }

      let fact = 0
      let norm = 0

      job.reports.forEach((d) => {
        if (d.PROF && d.PROF.time !== undefined) {
          fact += Number(d.PROF.time) * Number(d.PROF.value)
        }

        d.jobs.forEach((data) => {
          norm += Number(data.job.value)
        })
      })

      return {fact, norm}
    },
    getNames(t, sb) {
      const users = this.allUsers;

      const result = []
      const user = this.form.user || {}
      const reporter = this.form.executor || {}

      users.forEach(({label, value}) => {
        if (this.form.notifications.find((u) => u.value === value) || user.uid === value || reporter.uid === value || firebase.auth().currentUser.uid === value) {
          result.push({
            value: label,
            key: label
          })
        }
      })

      sb([
        {key: 'Все', value: 'Все'},
        ...result
      ])
    },
    async back() {
      await this.$router.push(`/dashboard/workorders-reports`)
    },
    onCopy() {
      this.$notify.success({
        offset: 60,
        title: 'Ссылка скопирована',
      });
    },
    async addObject(n) {
      this.form.object = n;
    },
    setStatus(status) {
      if (status.value === 'DONE' || status.value === 'IN_TEST') {
        if (!this.form.finish_dateunix || isNaN(this.form.finish_dateunix)) {
          this.form.finish_datetime = dayjs().format();
          this.form.finish_dateunix = dayjs(dayjs().format()).utc().unix()
        }
      }
    },
    deleteComment(i) {
      this.form.comments.splice(i, 1)

      this.updateComments();
    },
    deleteCommentImg(key, i) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const comments = [...this.form.comments];
        comments[key].files.splice(i, 1);
        this.form.comments = comments;

        this.updateComments();

      });
    },
    addComment() {
      const comments = this.form.comments || [];

      comments.push({
        ...this.comment,
        user: this.user,
        emails: this.getCommentEmails(this.comment)
      })

      this.comment = {
        text: '',
        files: []
      }

      this.form.comments = comments;
      this.updateComments();

      this.$refs.comment.clearValue()
    },
    getCommentEmails(comment) {
      const result = []

      this.allUsers.forEach(({label, _data}) => {
        if (comment.text.includes(label)) {
          result.push(_data.email)
        }
      })

      return uniq(result)
    },
    updateComments() {
      if (this.$route.params.id) {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('workorders')
          .doc(this.$route.params.id)
          .update({
            comments: this.form.comments,
          });
      }
    },
    addCategory(n) {
      this.form.category = n;
    },
    addUser(n) {
      this.form.executor = n;
    },
    async init() {
      this.fetchUser();
      if (this.$route.params.id) {
        await this.fetchData();
        this.isLoad = true
        if (this.$route.name === 'workorderCopy') {
          this.fetchIndex();
          this.form.datetime = dayjs().format();

        }
        const reports = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .where('workOrderId', '==', this.$route.params.id)
          .get()


        reports.forEach((d) => {
          const data = d.data();


          const index = this.form.inputObjects.findIndex(({id}) => data.wordOrderObject === id)
          if (index !== -1) {
            const jobIndex = this.form.inputObjects[index].jobs.findIndex(({
                                                                             name,
                                                                             uid
                                                                           }) => (uid === (data.workOrderJob && data.workOrderJob.id)) || (name === ((data.workOrderJob && data.workOrderJob.name) || data.name)))

            if (jobIndex !== -1) {
              if (!this.form.inputObjects[index].jobs[jobIndex].reports) {
                this.form.inputObjects[index].jobs[jobIndex].reports = []
              }
              this.form.inputObjects[index].jobs[jobIndex].reports.push({
                ...data,
                id: d.id
              })
            }
          }
        })


        this.form = {...this.form}
      } else {
        this.fetchIndex();
        this.isLoad = true
      }
    },
    sendReport() {
      this.$prompt('Пожалуйста введите email', 'Отправка наряда', {
        confirmButtonText: 'Отправить',
        inputValue: firebase.auth().currentUser.email,
        cancelButtonText: 'Закрыть',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Некорректный емайл',
      }).then(({value}) => {
        this.loading = true;
        const proxy = firebase.functions().httpsCallable('onMailReports');
        proxy(
          {
            projectId: this.$store.state.project.id,
            reportId: this.$route.params.id,
            email: value,
          },
        ).then(() => {
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Наряд отправлен на почту',
            type: 'success',
          });
        }).catch(() => {
          this.$notify({
            offset: 60,

            title: 'Ошибка',
            message: 'Произошла ошибка, попробуйте позже',
            type: 'error',
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    deleteReport() {
      this.$confirm('Вы действительно хотите удалить это задание?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('workorders')
          .doc(this.$route.params.id).delete()
          .then(async (data) => {

            for (let obj of this.form.inputObjects) {
              for (let job of obj.jobs) {
                for (let j of job.reports) {
                  if (job.reportId) {
                    try {
                      await firebase.firestore()
                        .collection('projects')
                        .doc(this.$store.state.project.id)
                        .collection('reports').doc(j.reportId).delete()
                    } catch (e) {
                    }
                  }
                }
              }
            }

            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Наряд удален',
              type: 'success',
            });
            setTimeout(() => {
              this.$router.push('/dashboard/workorders-reports');
            }, 1000);
          });
      });
    },
    fetchUser() {
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || firebase.auth().currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const user = subDoc.data();
            if (user.name.length && user.position && user.position.length) {
              this.isCreatedUser = subDoc.id;
            }
            this.user = {
              ...user,
              name: user.name || firebase.auth().currentUser.email,
              user_profile_id: subDoc.id,
            };
          });

        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    preview(file) {
      window.open(file, '_blank');
    },
    addFile(f) {
      this.form.files.push(f);
    },
    addFileComment(f) {
      this.comment.files.push(f);
    },
    deleteTmpImg(i) {
      const comment = {...this.comment};
      comment.files.splice(i, 1);
      this.comment = comment;
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    fetchData() {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('workorders')
        .doc(this.$route.params.id)
        .get().then((data) => {
          const subData = data.data();
          this.fileList = this.form.files.map((f, i) => {
            return {
              url: f,
              name: 'file__' + i,
            };
          });

          if (this.$route.name !== 'workorderCopy') {
            this.form = {
              ...this.form,
              ...this.comment,
              ...subData,
            };
          } else {
            const report = JSON.stringify({
              ...this.form,
              ...this.comment,
              ...subData,
            }).replace(/"reportId":"[^"]*"/g, '"reportId":null');
            this.form = JSON.parse(report);
          }

        });
    },
    fetchIndex() {
      return new Promise((resolve, reject) => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('workorders')
          .orderBy('index', 'desc').limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((data) => {
              this.form.index = Number(data.data().index) + 1;
            });
            resolve();
          });
      });
    },
    async save() {
      if (this.loader) return false;

      this.loader = true;

      if (!this.form.datetime) {
        this.$notify({
          offset: 60,

          title: 'Заполните все поля!',
          message: 'Пожалуйста заполните поле c датой',
          type: 'error',
        });
        return;
      }

      const user = firebase.auth().currentUser;
      //
      // for (let obj of JSON.parse(JSON.stringify(this.form.inputObjects))) {
      //
      //   for (let job of obj.jobs) {
      //     for (let report of job.reports) {
      //       if (!job.reportId) {
      //         const data = await firebase.firestore()
      //           .collection('projects')
      //           .doc(this.$store.state.project.id)
      //           .collection('reports')
      //           .add(getJobStructure({form: this.form, store: this.$store, index, job, obj, user: this.user}));
      //         job.reportId = data.id
      //         job.reportIndex = index
      //         index++
      //       } else {
      //         await firebase.firestore()
      //           .collection('projects')
      //           .doc(this.$store.state.project.id)
      //           .collection('reports').doc(job.reportId)
      //           .update(getJobStructure({form: this.form, store: this.$store, job, obj, user: this.user}));
      //       }
      //     }
      //   }
      // }


      if (!this.$route.params.id || this.$route.name === 'workorderCopy') {
        await this.fetchIndex();

        user.providerData.forEach(() => {
          firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('workorders')
            .add(JSON.parse(JSON.stringify({
              ...this.form,
              inputObjects: this.form.inputObjects.map((obj) => {
                return {
                  ...obj,
                  parentId: obj.parentId || null,
                  jobs: obj.jobs.map((j) => {
                    return {
                      ...j,
                      reports: []
                    }
                  })
                }
              }),
              planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
              userId: this.$store.state.company.uid || user.uid,
              user: this.user,
              datetime: dayjs(this.form.datetime).format(),
              dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              deadline_datetime: this.form.deadline_datetime ? dayjs(this.form.deadline_datetime).format() : null,
              deadline_dateunix: dayjs(dayjs(this.form.deadline_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              deadline_datetime_end: this.form.deadline_datetime_end ? dayjs(this.form.deadline_datetime_end).format() : null,
              deadline_dateunix_end: dayjs(dayjs(this.form.deadline_datetime_end).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              finish_datetime: dayjs(this.form.finish_datetime).format(),
              finish_dateunix: dayjs(dayjs(this.form.finish_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            }))).then(() => {
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Наряд добавлен',
              type: 'success',
            });
            setTimeout(() => {
              this.fetchIndex();
              this.$router.push('/dashboard/workorders-reports/');
            }, 1000);
          }).finally(() => {
            this.loader = true;
          })
            .catch((error) => {
              this.$notify({
                offset: 60,

                title: 'Упс... ',
                message: 'Произошла ошибка повторите позже',
                type: 'error',
              });
            });
        });
      } else {
        const removeIds = this.$refs.addJobsWork.getRemoveIds()

        for (let id of removeIds) {
          if (id) {
            await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('reports').doc(id).delete()
          }
        }


        const formData = JSON.parse(JSON.stringify({...this.form}))

        delete formData.user;
        delete formData.userId
        delete formData.index

        if (this.newAuthor) {
          formData.user = JSON.parse(JSON.stringify(this.newAuthor));
          formData.userId = this.newAuthor.uid
        }


        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('workorders')
          .doc(this.$route.params.id)
          .update({
            ...formData,
            inputObjects: this.form.inputObjects.map((obj) => {
              return {
                ...obj,
                parentId: obj.parentId || null,
                jobs: obj.jobs.map((j) => {
                  return {
                    ...j,
                    reports: []
                  }
                })
              }
            }),
            planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
            // userId: this.$store.state.company.uid || user.uid,
            // user: this.user,
            datetime: dayjs(this.form.datetime).format(),
            dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            deadline_datetime: this.form.deadline_datetime ? dayjs(this.form.deadline_datetime).format() : null,
            deadline_dateunix: dayjs(dayjs(this.form.deadline_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),

            deadline_datetime_end: this.form.deadline_datetime_end ? dayjs(this.form.deadline_datetime_end).format() : null,
            deadline_dateunix_end: dayjs(dayjs(this.form.deadline_datetime_end).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),

            finish_datetime: this.form.finish_datetime ? dayjs(this.form.finish_datetime).format() : null,
            finish_dateunix: this.form.finish_datetime ? dayjs(dayjs(this.form.finish_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix() : null,
          }).then(() => {


          this.$router.push('/dashboard/workorders-reports');

          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Наряд отредактирован',
            type: 'success',
          });
        }).finally(() => {
          this.loader = true;
        }).catch((error) => {
          this.$notify({
            offset: 60,

            title: 'Упс... ',
            message: 'Произошла ошибка повторите позже',
            type: 'error',
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
.tribute-container {
  background: #fff;
  z-index: 999;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0;

  ul {
    list-style-type: none;
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;

    li {
      padding: 8px 16px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        background: #409EFF;
        color: #fff;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.doc-search {
  position: relative;
  width: 20px;
  cursor: pointer;
  left: 86px;
  bottom: -34px;
}

.navigate-btn {
  margin-top: 20px;
  display: block;
}

.reports-create, .alert-report {
  margin: 0 auto;
  max-width: 382px;
  padding-top: 20px;
  width: calc(100% - 40px);
  overflow: hidden;
  padding-bottom: 100px;

  .add-jobs {
    display: flex;
    flex-direction: column;
  }

  .date-create {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h4 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0;

    small {
      font-size: 10px;
      font-weight: 400;
    }
  }
}

.add-btn {
  width: 100%;

  &.isSelect {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    margin-bottom: 2px;
    margin-top: 6px;
  }

  > > > .add {
    width: 100%;
  }

  margin-top: 6px;

  &.add-jobs {
    margin-top: 0;
  }
}

.select-job {
  margin-top: 20px;

  > > > .el-select {
    width: 100%;
  }
}

.report-li {
  span {
    max-width: 50%;
  }
}

.report-value {
  strong {
    font-weight: bold;
  }
}

@media screen and (max-width: 500px) {
  .report-value {
    width: 100%;
    justify-content: space-between !important;
  }

  .report-li {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;


    .el-icon-close {
      margin-bottom: 12px;
    }

    .col-vo, .time {
      display: flex;
      flex-direction: row;

      > > > .el-form-item__label {
        margin-right: 6px !important;
      }
    }

    .time {
      margin-left: 10px;
    }

    span {
      max-width: 100%;
      font-weight: bold;
    }
  }
}

.report-li-title {
  font-size: 14px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0px;
}

.report-add-job {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding: 20px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  .report-ul {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 22px;
  }

  .jobs-li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:last-child {
      border-bottom: none;
    }

    padding-bottom: 12px;
  }

  .report-li {
    display: flex;
    margin-top: 3px;
    justify-content: space-between;
    min-height: 58px;
    padding: 12px 0px;
    text-align: left;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;


    &.with-check {
      border-bottom: none;
      padding-bottom: 0px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.report-file {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}


.create-footer {
  display: flex;
  justify-content: center;
  //padding-bottom: 34px; // IOS ONLY
  padding-bottom: 7px;

  position: fixed;
  border-top: 1px solid #ddd;
  align-items: center;
  padding-top: 10px;
  max-width: 382px;
  width: calc(100% - 40px);
  bottom: 0;
  background: #fff;
  z-index: 3;

  .el-form-item {
    margin-bottom: 8px !important;
  }
}

.report-ul {
  width: 100%;
}

> > > .el-form-item, > > > .el-form-item__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .el-form-item__label {
    padding: 0 !important;
  }
}

.docs {
  > > > .el-form-item__content {
    align-items: flex-start;
  }
}

> > > .el-form-item {
  margin-bottom: 4px !important;
}

> > > .el-form-item__label {
  height: 32px !important;
}

.report-value {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  strong {
    opacity: 0.8;
    font-weight: bold;
  }

  > > > .el-input__inner {
    width: 92px;
    text-align: right;
    margin-right: 8px;
  }


}

.job-inputs {
  display: flex;
  align-items: center;
  margin-right: 4px;

  i {
    padding-left: 4px;
    cursor: pointer;
  }
}

.preview-images {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
  margin-top: 16px;
  margin-bottom: 16px;

  .preview-img {
    width: 92px;
    height: 92px;
    margin: 6px;
  }

  .controls {
    display: flex;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.3);
    width: 92px;
    height: 92px;
    border-radius: 6px;
    margin-top: -98px;
    z-index: 2;
    position: relative;
    align-items: center;

    i {
      font-size: 24px;
      color: #fff;
      margin: 0 12px;
      cursor: pointer;
    }
  }

  img {
    width: 92px;
    height: 92px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
    position: relative;
  }
}

.add-block {
  display: flex;
  justify-content: flex-end;
}

.line-data {
  padding: 5px 15px;
  margin-bottom: 10px;
  background: #fff;
  background: #f7f7f7;
  box-shadow: 0px 0px 8px 0px #ccc;
  border-radius: 5px;
}

.pipe-close {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: -42px;
  margin-top: 10px;
  font-size: 20px;
  cursor: pointer;

  i {
    margin-bottom: 10px;
  }

  > > > .add-btn-joint {
    z-index: 2;
    position: relative;
  }
}

.reports-edit-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;

  .i-container {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    padding: 6px;
    cursor: pointer;
    border: 1px solid #eee;
    color: #000;
    text-decoration: none;
    flex-direction: column;

    i {
      height: 24px;
    }

    span {
      font-size: 10px;
      margin-top: 6px;
    }

    &:hover {
      background: #eee;
    }
  }
}

.reports-create {
  padding: 0 20px;
}

.add-job {
  margin-top: -30px;
}

.reports-create {
  padding-top: 40px;
  //padding-bottom: 160px; // IOS ONLY
  padding-bottom: 117px;
}

.report-add-job {
  .line-data {
    padding-top: 24px;
    margin-bottom: 20px;
  }

  .report-ul.mul {
    margin-bottom: 0;
  }

  .add-block {
    margin-top: 30px;
  }

  .report-li > > > .el-form-item__label {
    height: 32px;
  }

  .col-vo {
    > > > .el-input__inner {
      width: 68px !important;
      padding: 0 5px !important;
    }
  }

  .time {
    > > > .el-input__inner {
      width: 58px !important;
      padding: 0 8px 0 2px !important;
      margin-right: 0px;
    }
  }
}

.reports-mul {
  > > > .el-form-item__label {
    margin-top: 2px;
  }

  > > > .el-form-item {
    margin-bottom: 10px;
  }
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 14px;
}

.links-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  align-items: center;

  a {
    color: #3676cb;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  i {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.8;
  }
}

.comments {
  display: flex;
  flex-direction: column;

  .comment {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .text {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.delete-btn {
  font-size: 12px;
  color: #ff4500;
  cursor: pointer;
}

.desc {
  text-align: left;
}

.progress-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #13ce66;
  min-width: 32px;
  height: 32px;
  border-radius: 18px;
  padding-left: 2px;
  padding-right: 2px;
  border: 2px solid #13ce66;
}

.main-tech-inputs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  strong {
    font-size: 14px;
    margin-top: 16px;
    margin-bottom: 3px;
  }
}

.tech-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  width: 100%;

  span {
    font-size: 13px;
    font-weight: bold;
  }
}

.disabled {
  div {
    opacity: 0.6;
    pointer-events: none !important;
  }
}
</style>
<style lang="scss">
.workorder-create {
  .el-form-item {
    margin-bottom: 2px !important;
  }


  .date-pick-workorder {
    .el-input--suffix .el-input__inner {
      padding-right: 0 !important;
    }

    input {
      font-size: 15px !important;
    }
  }
}


.desktop-header-left, .desktop-header-right {
  display: flex;
  align-items: center;
}

.desktop-header-selects {
  display: flex;
  align-items: center;

  .user-select {
    .el-form-item {
      min-width: 182px !important;
      max-width: 220px !important;

      width: 220px !important;
    }
  }

  .el-form-item {
    margin-bottom: 0;
    min-width: 158px;
    max-width: 158px;

    width: 158px;

    .multiselect__tags, .multiselect__single {
      color: #fff !important;
      background: #1e90ff;
    }

    .multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
      color: #fff !important;
      background: #1e90ff;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    .multiselect__select {
      border-left: 2px solid #fff;
    }

    .multiselect__select::before {
      color: #fff !important;
      border-color: #fff transparent transparent;
    }
  }
}

.desktop-show-create {
  display: none !important;
}

.create-one-work-or {
  .fa-chevron-right {
    font-size: 18px;
  }

  .arrow-main {
    font-size: 18px !important;
  }
}

@media screen and (min-width: 764px) {

  .object-container {
    justify-content: flex-start !important;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 8px;

    .add-main-job {
      margin-top: 0 !important;
      margin-left: 4px !important;
    }
  }

  .create-footer {
    justify-content: space-between;
  }

  .filter-footer-report {
    flex-direction: row !important;
  }


  .create-footer-report {
    display: flex;

    .filter-select-container {
      width: 50%;
    }

    .filter-footer-report {
      flex: 1;
      justify-content: flex-start !important;
      margin-right: 42px;
      display: flex;
    }
  }


  .add-main-job-des {
    justify-content: flex-start !important;
    padding-left: 180px;
  }

  .search-jobs-work {
    max-width: 40%;
    margin-top: 22px;
  }

  .create-one-work-or {
    .create-comment {
      max-width: 500px;
      flex-direction: column;

      .el-form-item__label {
        display: none;
      }
    }
  }

  .create-one-work-or {
    padding-bottom: 80px;


    .el-table .el-table__cell {
      padding: 4px 0;
    }


    .desktop-header {
      .multiselect__placeholder {
        color: #f1f1f1 !important;
      }

      .fix-bg {
        background: #409EFF;
        left: 4px;
        width: 62px;
        top: -2px;
        height: 52px;
        position: fixed;
        border-radius: 4px;
      }

      display: flex;
      justify-content: space-between;
      max-width: 1200px;
      width: 100%;
      flex: 1;
      align-items: center;
      margin: 0 auto;

      .desktop-header-right {
        max-width: 50%;
        margin-left: 100px;
      }
    }

    .prof-tech-desktop {
      margin-top: 32px;
      display: flex;
      box-sizing: border-box;

      align-items: flex-start;

      .line-title {
        display: flex;

        strong {
          font-size: 20px;
        }
      }


      .prof-desktop {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-right: 20px;
        box-sizing: border-box;
      }

      .tech-desktop {
        display: flex;
        padding-left: 20px;

        flex-direction: column;
        box-sizing: border-box;
        flex: 1;
      }
    }

    .report-file {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      box-sizing: border-box;
      padding-left: 20px;
      flex: 1;
      width: 100%;
    }

    .comment-textarea {
      .el-form-item__label {
        font-size: 17px;
      }

      width: 50%;

      .el-form-item {
        width: 100%;
      }

      .el-textarea__inner {
        height: 120px;
      }
    }

    .reports-create.workorder-create {
      background: #fff;
      border-radius: 4px;
      padding: 8px 20px;
      padding-bottom: 24px;
      box-sizing: border-box;
    }

    .create-comment {
      display: flex;
      margin-top: 20px;

      .comment-textarea {
        display: flex;
        justify-content: flex-start;

        .el-form-item__label {
          display: flex;
          padding: 0;
          justify-content: flex-start;
        }
      }
    }

    .add-desktop-obj {
      display: flex;
      justify-content: flex-start;
      width: 100px;

      .desktop-show-create {
        font-size: 15px !important;
      }
    }

    .one-report-search {
      margin-bottom: 8px !important;
    }

    .fas.fa-chevron-right {
      font-size: 18px !important;
    }

    .one-report-search {
      display: flex;
    }

    .reports-create {
      max-width: 1200px !important;
      width: 100% !important;
    }

    .desktop-show-create {
      display: flex !important;
    }

    .mob-show-create {
      display: none !important;
    }

    .create-footer {
      max-width: 1200px !important;
      width: calc(100% - 40px) !important;
      padding: 8px 16px;
      margin-left: -20px;
      box-sizing: border-box;
    }

    .create-footer-container {
      justify-content: flex-end !important;
    }
  }

  .one-reports-create, .one-reports-update {
    display: none !important;
    padding: 0 20px;
    box-sizing: border-box;

    .bm-burger-button {
      .line-style {
        background-color: #000 !important;
      }
    }
  }


  .create-one-work-or {
    display: flex;
    width: 100vw;
    justify-content: center;
    margin-top: -34px;
    padding-bottom: 40px;
    height: 100%;
    min-height: 100vh;
    background: #f1f1f1;
  }


  .doc-search-header {
    width: 25px;
    margin-top: 6px;
  }

  .copy-header {
    font-size: 28px;
    color: black;
    margin: 0 12px;
  }


  .progress-circle-header {
    margin-left: 16px;
  }

  .header-search {
    margin-left: 8px;
    background: #fff;
  }

  .desktop-header-right {
    .el-date-editor {
      width: 280px;
      background: #fff;
    }
  }

  .descktop-line-info {
    display: flex;
    margin-top: 8px;

    .line-category {
      margin: 0 16px;
    }
  }

  .descktop-line-li {
    flex-direction: column;
    display: flex;
    flex: 1;
    align-items: flex-start;

    .filter-select-container {
      max-width: 340px;
      width: 100%;

      .filter-select {
        width: 320px;
      }
    }

    .add-btn {
      max-width: 340px;
      width: 100%;
    }

    strong {
      align-items: center;
      color: #000;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .report-li-title-desktop {
    border: 1px solid #DCDFE6;
    height: 40px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #0e1011 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    flex: 1;
    max-width: 100%;
    margin-right: 8px;

    span {
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 300px;
      overflow: hidden;
    }
  }

  .two-desc-line {
    display: flex;
    align-items: flex-start;
    margin-top: 28px;
  }

  .create-comment {
    .el-textarea__inner {
      width: 500px !important;
      height: 140px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/Create.vue